import { noneProfile } from "assets";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import { DialogFooter } from "components/ui/dialog";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectLabel, SelectItem } from "components/ui/select"; // or wherever your library path is
import { Switch } from "components/ui/switch";
import { Loader, RotateCcw, X } from "lucide-react";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  editItemCategories: string;
  isDailogRoster: boolean;
  filteredData: any;
  userShopShiftGroup: any;
  setIsDailogIsRoster: (value: boolean) => void;
  setFilteredData: any;
  searchTextInput: string;

  onUploadSuccessRoster: ({ status }: { status: string }) => void;
  resetStatus: ({ status }: { status: string }) => void;
}
export default function DailogRoster({
  searchTextInput,
  isDailogRoster,
  setIsDailogIsRoster,
  filteredData,
  userShopShiftGroup,
  editItemCategories,
  setFilteredData,
  onUploadSuccessRoster,
  resetStatus,
}: DialogProps) {
  const { showDialogConfirm, showDialogMessage } = appStore();
  const [shiftData, setShiftData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const currentYear = new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

  const getDaysInMonth = (month: number, year: number): number => new Date(year, month + 1, 0).getDate();

  const getWeekday = (day: number, month: number, year: number): string => {
    return new Date(year, month, day).toLocaleDateString("en-US", {
      weekday: "long",
    });
  };

  const daysInMonth = getDaysInMonth(selectedMonth, selectedYear);
  const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  const generateShiftDatas = () => {
    const data: any[] = [];
    for (const employee of filteredData || []) {
      const record: any = {
        name: employee.local_name,
        img: employee.picture,
        position: employee.position ? employee.position : "",
        months: selectedMonth + 1,
        years: selectedYear,
        employee_id: employee.employee_id ? employee.employee_id : "",
        dayoff: employee.day_off,
      };

      for (let i = 1; i <= 31; i++) {
        const date = new Date(selectedYear, selectedMonth, i);
        if (date.getMonth() !== selectedMonth) break; // Skip invalid dates like Jun 31

        const dayName = date.toLocaleDateString("en-US", { weekday: "long" }); // "Monday", "Tuesday", etc.
        const isDayOff = employee.day_off
          ?.split(",")
          .map((s: any) => s.trim().toLowerCase())
          .includes(dayName.toLowerCase());

        record[`day_${i}`] = isDayOff ? "" : employee.shift_group_id;
      }

      data.push(record);
    }
    setShiftData(data);
    return data;
  };

  const generateShiftData = async () => {
    setIsLoading(true); // Show loading
    const data: any[] = [];
    for (const employee of filteredData || []) {
      const record: any = {
        name: employee.local_name,
        img: employee.picture,
        position: employee.position ? employee.position : "",
        months: selectedMonth + 1,
        years: selectedYear,
        employee_id: employee.employee_id ? employee.employee_id : "",
        dayoff: employee.day_off,
        shiftGroupId: employee.shift_group_id,
      };
      // for (let i = 1; i <= 31; i++) {
      //   const dayName = getDayNameFromDate(i); // E.g., "Mon", "Tue", etc.
      //   const isDayOff = employee.day_off?.split(",").includes(dayName);
      //   record[`day_${i}`] = isDayOff ? "" : employee.shift_group_id;
      // }
      for (let i = 1; i <= 31; i++) {
        const date = new Date(selectedYear, selectedMonth, i);
        if (date.getMonth() !== selectedMonth) break; // Skip invalid dates like Jun 31

        const dayName = date.toLocaleDateString("en-US", { weekday: "long" }); // "Monday", "Tuesday", etc.
        const isDayOff = employee.day_off
          ?.split(",")
          .map((s: any) => s.trim().toLowerCase())
          .includes(dayName.toLowerCase());

        record[`day_${i}`] = isDayOff ? "" : employee.shift_group_id;
      }

      data.push(record);
      // Optional delay to simulate processing and allow React to render
      await new Promise((res) => setTimeout(res, 0));
    }

    setShiftData(data);
    setIsLoading(false); // Hide loading
  };

  useEffect(() => {
    if (filteredData?.length) {
      generateShiftData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredData]);
  useEffect(() => {
    if (filteredData?.length) {
      generateShiftDatas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredData, selectedMonth, selectedYear]);

  const handleChange = (rowIndex: any, dayKey: any, val: any) => {
    let shiftId = "";

    // If val is a known local_description, map to shift_group_id
    const matchedByDescription = userShopShiftGroup?.find((item: any) => item.local_description === val);

    if (matchedByDescription) {
      shiftId = matchedByDescription.shift_group_id;
    } else if (val === "" || userShopShiftGroup?.some((item: any) => item.shift_group_id === val)) {
      // val is either "" or a shift_group_id directly
      shiftId = val;
    }
    setShiftData((prev: any) =>
      prev.map((row: any, i: any) =>
        i === rowIndex
          ? {
              ...row,
              [dayKey]: shiftId,
            }
          : row
      )
    );
  };

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const handleReset = () => {
    resetStatus({ status: "yes" });
    // setShiftData(generateShiftDatas);
  };
  const monthAbbr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthLabel = monthAbbr[selectedMonth] || "";
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");

  const submitShopEmployeeTimesheetSetup = async () => {
    setLoadingSubmit(true);
    try {
      let url: string = "";
      url = RouteApi.submitShopEmployeeTimesheetSetup;
      url += `token=${token}`;
      const data = {
        shop_id: shopId,
        records: shiftData,
        month: selectedMonth + 1,
        year: selectedYear,
        option: advance ? "advance" : "basic",
      };
      await RequestApi(url, {
        data,
      })
        .then((responses) => {
          if (responses.status === "success") {
            setLoadingSubmit(false);
            setIsDailogIsRoster(false);
            // onUploadSuccessRoster({
            //   status: responses.status,
            // });
            onUploadSuccessRoster({
              status: responses.status,
            });
            showDialogMessage({
              title: responses.status,
              message: responses.msg,
              barrierDismissible: true,
              status: responses.status,
            });
          } else {
            showDialogMessage({
              title: responses.status,
              message: responses.msg,
              barrierDismissible: false,
            });
          }
        })
        .catch((err) => {
          setIsDailogIsRoster(true);
        });
    } catch (error) {
      setIsDailogIsRoster(true);
      AppLog.show({
        message: `[submitShopEmployeeTimesheetSetup]`,
        status: StatusMsg.error,
        error,
      });
      // setLoadingSubmit(false);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const getShopEmployeeAll = async () => {
    setIsLoading(true);
    try {
      let url = `${RouteApi.getShopEmployeeAll}token=${token}`;
      const data = {
        shop_id: shopId,
        department: editItemCategories,
        search_text: searchTextInput,
      };

      const responses = await RequestApi(url, { data });

      if (responses.status === "success") {
        const employees = responses.user_shop_employees?.data || [];

        const processedData: any[] = [];

        for (const employee of employees) {
          const record: any = {
            name: employee.local_name,
            img: employee.picture,
            position: employee.position || "",
            months: selectedMonth + 1,
            years: selectedYear,
            employee_id: employee.employee_id || "",
            dayoff: employee.day_off,
            shiftGroupId: employee.shift_group_id,
          };
          for (let i = 1; i <= 31; i++) {
            const dayName = getDayNameFromDate(i); // Assuming you have this function
            const isDayOff = employee.day_off?.split(",").includes(dayName);
            record[`day_${i}`] = isDayOff ? "" : employee.shift_group_id;
          }
          processedData.push(record);
        }

        setShiftData(processedData);
        setIsLoading(false);
        // setFilteredData(responses.user_shop_employees.data);
      } else {
        console.error("Failed to fetch employee data");
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Error fetching employees:", err);
      setIsLoading(false);
    }
  };

  const [advance, setAdvance] = useState(() => {
    return localStorage.getItem("check") === "true";
  });
  // function getDayNameFromDate(dayNumber: number): string {
  //   const date = new Date(2025, 4, dayNumber); // 4 = May (0-indexed)
  //   return date.toLocaleDateString("en-US", { weekday: "long" }); // e.g., "Saturday"
  // }
  function getDayNameFromDate(day: number): string {
    const date = new Date(selectedYear, selectedMonth, day); // selectedMonth must be 0-indexed (Jan = 0)
    return date.toLocaleDateString("en-US", { weekday: "short" }); // Returns "Mon", "Tue", etc.
  }

  return (
    <>
      <Dialog open={isDailogRoster}>
        <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} isShowBtnXClose={false} className="lg:max-w-[1800px]  h-[calc(100vh-80px)] custom-dialog-class flex flex-col  ">
          <DialogHeader>
            <div className="flex items-center justify-between ">
              <div className="flex flex-col gap-2">
                <DialogTitle>Create Timesheet From Roster Setup</DialogTitle>
                <DialogDescription>
                  To create a timesheet roster, start by selecting the dates for the work period. Then, assign shifts or working hours for each employee on the corresponding days.
                </DialogDescription>
              </div>
              <div className="flex gap-4 items-center me-[30px]">
                <HoverCardDetail
                  title="Reload"
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">
                        Reload the staff ( Maximum 50 ) timesheets based on the current search, department, and filter selections.
                      </p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>Use the existing roster to auto-fill employee working hours.</li>
                        <li>Quickly regenerate timesheets for a specific period or shift cycle.</li>
                        <li>Ensure consistency between the roster and recorded timesheets.</li>
                        <li>Useful for handling shift changes, missed entries, or corrections.</li>
                      </ul>
                    </>
                  }
                >
                  <div
                    onClick={() => {
                      // setLoading(true);
                      getShopEmployeeAll();
                    }}
                    className=" cursor-pointer w-8 h-8 flex items-center justify-center bg-blue-500 text-white p-2 rounded-full"
                  >
                    <i className="fa-solid fa-users"></i>
                  </div>
                </HoverCardDetail>
                <HoverCardDetail
                  title="Reset"
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">Reset and generate employee timesheets based on the predefined roster.</p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>Use the existing roster to auto-fill employee working hours.</li>
                        <li>Quickly regenerate timesheets for a specific period or shift cycle.</li>
                        <li>Ensure consistency between the roster and recorded timesheets.</li>
                        <li>Useful for handling shift changes, missed entries, or corrections.</li>
                      </ul>
                    </>
                  }
                >
                  <div
                    onClick={() => {
                      showDialogConfirm({
                        titileButtonCancel: "No, Cancel",
                        title: "Reset",
                        message: "Do you want to Reset ?",
                        onSubmit() {
                          handleReset();
                        },
                      });
                    }}
                    className=" cursor-pointer w-8 h-8 flex items-center justify-center bg-red-500 text-white p-2 rounded-full"
                  >
                    <RotateCcw />
                  </div>
                </HoverCardDetail>
                <HoverCardDetail
                  title=""
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">
                        Switch between <strong>Basic</strong> and <strong>Advanced</strong> modes depending on your workflow needs.
                      </p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>
                          <strong>Basic Mode:</strong> Simplified layout with only the most essential options and actions.
                        </li>
                        <li>
                          <strong>Advanced Mode:</strong> Reveals full configuration options including fine-grained controls, custom rules, and power tools.
                        </li>
                        <li>Use the mode that matches your task complexity or user preference.</li>
                      </ul>
                    </>
                  }
                >
                  <div className="flex items-center justify-center mt-[2px] ">
                    <Switch
                      checked={advance}
                      onCheckedChange={(checked) => {
                        setIsLoading(true);
                        // setTimeout(() => {
                        setIsLoading(false);
                        setAdvance(checked);
                        localStorage.setItem("check", checked.toString());
                        // }, 300);
                      }}
                    />
                  </div>
                </HoverCardDetail>

                <p className="text-md w-[80px]  ">{advance ? "Advance" : "Basic"} </p>
              </div>
            </div>
            <div
              onClick={() => {
                setIsDailogIsRoster(false);
                setShiftData([]);
                resetStatus({ status: "no" });
              }}
              className="absolute flex items-center justify-center right-3 top-[16px] z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-8 h-8 border border-gray-300 "
            >
              <X size={18} />
            </div>
          </DialogHeader>
          <div className="flex justify-between items-center mt-5">
            <div className="flex items-center gap-4  w-full ">
              <HoverCardDetail
                title="Select Month & Year"
                description={
                  <>
                    <p className="mb-2 font-medium text-sm dark:text-white">Choose a specific month and year to filter, view, or generate time-based records.</p>
                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                      <li>View timesheets, attendance, or reports for a selected time period.</li>
                      <li>Useful for monthly payroll, scheduling, or performance tracking.</li>
                      <li>Ensures actions apply to the correct billing or reporting cycle.</li>
                    </ul>
                  </>
                }
              >
                <div className="flex">
                  <Select
                    value={selectedYear.toString()}
                    onValueChange={(val) => {
                      setSelectedYear(Number(val));
                      handleReset();
                    }}
                  >
                    <SelectTrigger className="w-[180px] py-3">
                      <SelectValue placeholder="Select Year" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectLabel>Years</SelectLabel>
                        {years.map((year) => (
                          <SelectItem key={year} value={`${year}`}>
                            {year}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </HoverCardDetail>
              <HoverCardDetail
                title="Select Month & Year"
                description={
                  <>
                    <p className="mb-2 font-medium text-sm dark:text-white">Choose a specific month and year to filter, view, or generate time-based records.</p>
                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                      <li>View timesheets, attendance, or reports for a selected time period.</li>
                      <li>Useful for monthly payroll, scheduling, or performance tracking.</li>
                      <li>Ensures actions apply to the correct billing or reporting cycle.</li>
                    </ul>
                  </>
                }
              >
                <div className="flex">
                  <Select
                    value={selectedMonth.toString()}
                    onValueChange={(val) => {
                      setSelectedMonth(Number(val));
                      handleReset();
                    }}
                  >
                    <SelectTrigger className="w-[180px] py-3">
                      <SelectValue placeholder="Select Month" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectLabel>Months</SelectLabel>
                        {months.map((month, index) => (
                          <SelectItem key={index} value={`${index}`}>
                            {month}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </HoverCardDetail>
            </div>
          </div>

          <div
            className={`
             no-scrollbar overflow-x-scroll overflow-y-scroll lg:-w-[1800px] md:-w-[800px] mb-[50px] overflow-hidden `}
          >
            {isLoading ? (
              <SkeletonMusicLibrariesTable />
            ) : (
              <table className="w-full h-full  border-b text-center rounded-md border-collapse  ">
                <thead className="sticky z-10 top-0 left-0 text-xs text-gray-700  bg-gray-50 dark:bg-[#2c3a52] dark:text-gray-400">
                  <tr>
                    <th className="text-start px-4 border sticky left-0 top-0 bg-gray-50 dark:bg-[#2c3a52]">Image</th>
                    {/* <th className="py-4 px-5 border">Image</th> */}
                    {daysArray.map((day) => {
                      const weekday = getWeekday(day, selectedMonth, selectedYear);

                      const isWeekend = weekday === "Sunday" || weekday === "Saturday";
                      return (
                        <th key={day} className="py-4 px-5 border">
                          <p className="text-md whitespace-nowrap">
                            {monthLabel}, {day}, {selectedYear}
                          </p>
                          <p className={`text-gray-500 ${isWeekend ? "text-red-700" : ""}`}>{weekday}</p>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {shiftData.map((item: any, rowIndex: any) => {
                    return (
                      <tr key={rowIndex} className=" border-b dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-[#2c3a52]">
                        <td className="bg-white overflow-hidden dark:bg-[#020817] sticky left-0 z-30 flex items-center justify-center  dark:hover:bg-[#2c3a52] ">
                          <td className="">
                            <div className="gap-3 flex items-center py-2 rounded-md  w-[150px] ">
                              <ImageUrl src={!item.img ? noneProfile : item.img} className=" h-[45px] w-[45px] rounded-full" alt={item.img} />
                              <div className="flex flex-col text-start ">
                                <span className="w-full font-medium line-clamp-2 leading-none lg:text-md md:text-sm text-[13px]">{item.name}</span>
                                <span className="text-sm text-muted-foreground line-clamp-1">{item.position}</span>
                              </div>
                            </div>
                          </td>
                        </td>

                        {daysArray.map((day) => {
                          const dayKey = `day_${day}`;
                          const shiftId = item[dayKey];

                          const shift = userShopShiftGroup?.find((s: any) => s.shift_group_id === shiftId);

                          const selectedValue = shift ? shift.local_description : "off";

                          const switchValue = shift ? true : false;

                          return (
                            <td key={dayKey} className="py-3 px-3">
                              {advance ? (
                                <Select value={selectedValue} onValueChange={(val) => handleChange(rowIndex, dayKey, val)}>
                                  <SelectTrigger className="w-[120px]">
                                    <SelectValue />
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectGroup>
                                      {userShopShiftGroup?.map((items: any, index: number) => (
                                        <SelectItem key={index} value={items.local_description}>
                                          {items.local_description}
                                        </SelectItem>
                                      ))}
                                      <SelectItem value="off">Off</SelectItem>
                                    </SelectGroup>
                                  </SelectContent>
                                </Select>
                              ) : (
                                <Switch
                                  checked={switchValue}
                                  onCheckedChange={(checked) => {
                                    const newValue = checked ? item.shiftGroupId ?? "" : "";
                                    handleChange(rowIndex, dayKey, newValue);
                                  }}
                                />
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                  {/* <ToggleItems id={item.id} dayoff={item.dayoff} currentDay={dayName} /> */}
                </tbody>
              </table>
            )}
          </div>

          <DialogFooter className=" fixed bottom-[10px] right-5">
            {/* <div className="flex justify-end gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] right-5 "> */}
            <HoverCardDetail
              title="Submit"
              description={
                <>
                  <p className="mb-2 font-medium text-sm dark:text-white">Finalize and submit the current data for processing, saving, or review.</p>
                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                    <li>Ensure all required fields are completed before submission.</li>
                    <li>Once submitted, changes may be locked or require admin approval.</li>
                    <li>Triggers validation, saves data, and notifies relevant stakeholders if applicable.</li>
                    <li>Ideal for finalizing timesheets, form entries, or configuration settings.</li>
                  </ul>
                </>
              }
            >
              <button
                onClick={() => {
                  submitShopEmployeeTimesheetSetup();
                }}
                className="w-[100px] h-[40px] px-5 mt-6 flex items-center justify-center  bg-[#2563eb] text-white text-lg py-2 rounded-lg"
              >
                {loadingSubmit ? <Loader className="animate-spin" /> : "Submit"}
              </button>
            </HoverCardDetail>
            {/* </div> */}
          </DialogFooter>
          {loadingSubmit && <div className="flex absolute top-0 left-0 w-full h-full  z-[100] rounded-md"></div>}
        </DialogContent>
      </Dialog>
    </>
  );
}
